import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { QuizPerformanceFragmentDoc } from '../../fragments/generated/QuizPerformance';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RetakeQuizMutationVariables = Types.Exact<{
  input: Types.RetakeQuizInput;
}>;


export type RetakeQuizMutation = { retakeQuiz: { quizPerformance?: { id: string, entityId: string, isSubmitted: boolean, score?: number | null, correctAnswersCount?: number | null, status: Types.PerformanceStatusEnum, startedOn?: string | null, timeSpent: number, result?: Types.QuizResultEnum | null, maxScore?: number | null, attemptId: string, updatedAt: string, userContentFeedback?: { id: string } | null, maxSubmissionDetails?: { score?: number | null, timeSpent: number, maxScore?: number | null } | null, attempts?: Array<{ attemptId: string, score?: number | null, correctAnswersCount?: number | null, status: Types.PerformanceStatusEnum, maxScore?: number | null, timeSpent: number, isSubmitted: boolean, updatedAt?: string | null, result?: Types.QuizResultEnum | null, scorePercentage?: number | null }> | null, user?: { id: string, name?: string | null } | null } | null } };


export const RetakeQuizDocument = /*#__PURE__*/ gql`
    mutation retakeQuiz($input: RetakeQuizInput!) {
  retakeQuiz(input: $input) {
    quizPerformance {
      ...QuizPerformance
    }
  }
}
    ${QuizPerformanceFragmentDoc}`;

export function useRetakeQuizMutation() {
  return Urql.useMutation<RetakeQuizMutation, RetakeQuizMutationVariables>(RetakeQuizDocument);
};